<template>
  <v-container>
    <loader :isLoading="isLoading"></loader>
    <form-component
      :formData="formData"
    >
    </form-component>
  </v-container>
</template>

<script>
import Loader from '../../../components/utilities/Loader.vue';
import FormComponent from '../../../components/ui/FormComponent.vue';

import utilities from '../../../utilities';

const { TextUtil } = utilities;

export default {
  name: 'SpecimenTypeForm',
  components: {
    FormComponent,
    Loader,
  },
  props: {
    onSubmit: Function,
    isLoading: Boolean,
    specimenType: Object,
  },
  data() {
    return {
      formData: {
        onSubmit: this.onSubmit,
        model: this.specimenType,
        widgets: [
          {
            type: 'text',
            name: 'name',
            label: 'Name',
            value: '',
            counter: 100,
            maxLength: 100,
            rules: [
              (v) => !!v || 'Name is required',
            ],
          },
          {
            type: 'text',
            name: 'code',
            label: 'Code',
            value: '',
            counter: 100,
            maxLength: 100,
            // rules: [
            //   (v) => !!v || 'Code is required',
            // ],
          },
          {
            type: 'textarea',
            name: 'description',
            label: 'Description',
            value: '',
            counter: 255,
            maxLength: 255,
            rules: [
              (v) => !!v || 'Description is required',
            ],
          },
          {
            type: 'button',
            btnType: 'submit',
            name: 'save',
            label: 'Save',
            color: 'primary',
            value: null,
          },
        ],
      },
    };
  },
  watch: {
    // eslint-disable-next-line object-shorthand
    'formData.widgets.0.value'(newValue) {
      if (this.onChangeName) {
        clearTimeout(this.onChangeName);
        this.onChangeName = null;
      }
      const { _id, name, code } = this.specimenType || {};

      this.onChangeName = setTimeout(() => {
        const newCode = TextUtil.camelize(newValue);
        const similarName = newValue !== name;
        this.formData.widgets[1].value = (!code || similarName)
          ? newCode
          : code;
      }, 500);

      if (_id) {
        if (newValue !== name) {
          this.$set(this.warning,
            'name',
            'Changing the specimen type <b>name</b> can lead to <b>data loss</b>');
        } else {
          this.$delete(this.warning, 'name');
        }
      }
    },
  },
};
</script>
